import {Component, signal} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {BackButton} from '../../../../assets/shared/back-button/back-button';
import {TestingInterfaceRoute} from './interface/testing.interface';
import {dinamicQuestionModules} from '../../../data/questionData';
import {DeclensionPipe} from '../../../core/pipe/declension-pipe';
@Component({
  selector: 'app-testing',
  imports: [
    BackButton,
    DeclensionPipe,
  ],
  templateUrl: './testing.html',
  styleUrl: './testing.scss',
})
export class Testing {

  public typeModule?:TestingInterfaceRoute ={}
  public coursesId?: string;
  public moduleTitle  = signal<string>('');
  public countQuestion = signal<number>(0);


  constructor(private activeRoute:ActivatedRoute,private router:Router) {
    this.typeModule = {
      type:this.activeRoute.snapshot.paramMap.get('type')!,
      module:this.activeRoute.snapshot.paramMap.get('module')!
    }

    this.coursesId = this.activeRoute.snapshot.parent?.paramMap.get('coursesId')!;
    const moduleData =  dinamicQuestionModules[Number(this.coursesId) - 1]?.modules[Number(this.typeModule.module) - 1];

    this.moduleTitle.set(moduleData?.moduleTitle || '')
    this.countQuestion.set(moduleData?.questions?.length || 0 )

  }


  public routeTest(){
    this.router.navigate([this.coursesId, 'test', this.typeModule?.type, this.typeModule?.module]);
  }

  protected readonly Number = Number;
}
